// anzeigeOptik.js — welche Optik ein Hallenbildschirm nutzt (22.10.2026).
//
// Gespeichert vom Plattform-Admin in der Modus-Übersicht (Reiter „Anzeige /
// Display“) unter modus_display_config global/global, Feld `optik`. Fehlt ein
// Eintrag, gilt die neue Turniertag-Optik. Wählbar sind nur Bildschirme, deren
// bisherige Optik es noch gibt.
//
// Abschrift von backend/utils/anzeigeOptik.js; der Test
// backend/utils/__tests__/anzeigeOptik.test.js vergleicht beide.
// Eine Adresse kann die Einstellung für genau diesen Schirm übersteuern:
// ?optik=alt oder ?optik=neu (z. B. ein alter Beamer-Rechner).

const OPTIK_BILDSCHIRME = ['punktetafel', 'kataTafel', 'turnierbaum'];
const OPTIK_WERTE = ['neu', 'alt'];

// Für die Oberfläche: was der Schirm ist, wo er läuft, was „bisherige“ heißt
const OPTIK_TEXTE = {
  punktetafel: {
    name: 'Punktetafel',
    ort: 'Mattenbildschirm /display/<Matte>',
    neu: 'Turniertag-Tafel mit Rundenname, Bildern, Verwarnungen und Siegerbild',
    alt: 'Große Zahlen auf Schwarz, Uhr in der Mitte',
  },
  kataTafel: {
    name: 'Kata-Tafel',
    ort: 'Formen-Leinwand /formen-display',
    neu: 'Turniertag-Tafel mit Noten, Streichung, Rangliste und Siegerbühne',
    alt: 'Raster mit Kopfband, Ranglistenspalte und Fußleiste',
  },
  turnierbaum: {
    name: 'Turnierbaum',
    ort: 'Verwaltung, Bracket einer Kategorie',
    neu: 'Baum mit Schnitt-Animation, Trostrunde und Kampf um Platz 3 darunter',
    alt: 'Linienbaum wie bisher',
  },
};

/** Nur bekannte Bildschirme mit 'neu' oder 'alt'; alles andere fällt weg. */
function bereinigeOptik(roh) {
  const aus = {};
  if (!roh || typeof roh !== 'object' || Array.isArray(roh)) return aus;
  for (const k of OPTIK_BILDSCHIRME) {
    if (OPTIK_WERTE.includes(roh[k])) aus[k] = roh[k];
  }
  return aus;
}

/** Optik eines Bildschirms aus der gespeicherten Einstellung, Standard 'neu'. */
function optikFuer(optik, bildschirm) {
  return bereinigeOptik(optik)[bildschirm] === 'alt' ? 'alt' : 'neu';
}

/** ?optik=alt|neu aus einer Adresse (search-Teil), sonst null. */
function optikAusAdresse(search) {
  try {
    const w = new URLSearchParams(search || '').get('optik');
    return OPTIK_WERTE.includes(w) ? w : null;
  } catch { return null; }
}

module.exports = { OPTIK_BILDSCHIRME, OPTIK_WERTE, OPTIK_TEXTE, bereinigeOptik, optikFuer, optikAusAdresse };
